/**
 * Which audios a transcription queue or statistic reads (backend spec 015):
 * phrase recordings, initial-data spoken answers, or both.
 */
export const TRANSCRIPTION_SOURCES = ['all', 'phrase', 'initialAnswer'] as const;
export type TranscriptionSource = (typeof TRANSCRIPTION_SOURCES)[number];

/** From a URL parameter: anything unknown reads as both. */
export const transcriptionSourceOf = (value: string | null | undefined): TranscriptionSource =>
  TRANSCRIPTION_SOURCES.includes(value as TranscriptionSource) ? (value as TranscriptionSource) : 'all';

/** The query parameter to send: none for both, so older backends keep working. */
export const sourceParam = (source: TranscriptionSource) => (source === 'all' ? undefined : source);
